import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	moreButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moreButtonLabel: {
		id: 'software-releases-version-related-work.category-filter.more-lozenge.more-button-label',
		defaultMessage: '+{count} more',
		description:
			'The more button to display more related work categories, when the number of categories exceeds 5',
	},
});
export default messages;
